import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NetworkConstants, TransactionLog } from 'diwimamodelweb/lib';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { detectNavigator } from 'diwimamodelweb/lib/utils/detectNavigator';
import { environment } from 'src/environments/environment';
import { Firestore, collection, doc, setDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class TransactionLogService {
  private Ifirestore = inject(Firestore);

  constructor(
    private firestore: AngularFirestore,
    // private userService: UserService
  ) { }

  createLog(user: any, referenceId: string, referenceType: string, newValue: any): TransactionLog[] {
    const determineN = detectNavigator(navigator)
    const {contextId, displayName, identifier} = user
    const logItem = new TransactionLog(
      contextId, 
      referenceId,
      referenceType,
      displayName, 
      identifier,
      "RC-Web",
      environment.appName,
      environment.versionNumber,
      environment.versionCode.toString(),
      `${determineN.osName} ${determineN.browserName}`, 
      determineN.fullVersion
    )
    logItem.setCreate(newValue)
    return [
      logItem
    ]
  }

  deleteDocumentLog(user: any, referenceId: string, referenceType: string, oldValue: any): TransactionLog {
    const determineN = detectNavigator(navigator)
    const {contextId, displayName, identifier} = user
    const logItem = new TransactionLog(
      contextId, 
      referenceId,
      referenceType,
      displayName, 
      identifier,
      "RC-Web",
      environment.appName,
      environment.versionNumber,
      environment.versionCode.toString(),
      `${determineN.osName} ${determineN.browserName}`, 
      determineN.fullVersion
    )
    logItem.setDocumentDelete(oldValue)
    return logItem
  }
  
  determineDiff(user: any, updates: any, referenceId: string, referenceType: string): Promise<TransactionLog[]> {
    const determineN = detectNavigator(navigator)
    return new Promise(async (resolve, reject) => {
      try {
        const {contextId, displayName, identifier} = user
        let listTransactionLog: TransactionLog[] = []
        for (let [key, value] of Object.entries(updates)) {
          const {oldValue, newValue} = value as any
          const logItem = new TransactionLog(
            contextId, 
            referenceId,
            referenceType,
            displayName, 
            identifier,
            "RC-Web",
            environment.appName,
            environment.versionNumber,
            environment.versionCode.toString(),
            `${determineN.osName} ${determineN.browserName}`, 
            determineN.fullVersion
          )
          if (!oldValue && newValue) {
            // create
            logItem.setUpdate(key, oldValue, newValue)
          } else if (oldValue && !newValue) {
            // delete 
            logItem.setDelete(key, oldValue)
          } else {
            // update.. 
            logItem.setUpdate(key, oldValue, newValue)
          }

          listTransactionLog.push(
            logItem
          )
        }
        resolve(listTransactionLog)
      } catch (error) {
        reject(error)
      }
    })
  }

  saveTransactionLog(items: TransactionLog[]): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        let promiseArray = []
        items.forEach((logItem: TransactionLog) => {
          // const docRef = this.firestore.collection(NetworkConstants.COLLECTION_TRANSACTION_LOG).doc().ref
          const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_TRANSACTION_LOG));
          logItem.identifier = docRef.id
          const cleanedLogItem = removeUndefined(logItem)
          promiseArray.push(
          setDoc(docRef, {...cleanedLogItem})
            // this.firestore.collection(NetworkConstants.COLLECTION_TRANSACTION_LOG).doc(logItem.identifier).set({...cleanedLogItem})
          )
        })
        await Promise.all(promiseArray)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }
}
